// extracted by mini-css-extract-plugin
export default {"menuBlock":"wE-z","title":"xE-z","nav":"yE-z","flexCell":"zE-z","facetLink":"AE-z"};